define.alias("ember-basic-dropdown/modifiers/basic-dropdown-trigger", "media/modifiers/basic-dropdown-trigger");